// extracted by mini-css-extract-plugin
module.exports = {"clock":"ChessClock_clock__190-d"};